import React from 'react';
import './Brands.css';

const Brands: React.FC = () => {
  const logos = [
    'https://lh3.googleusercontent.com/4XhCiaAbMUlFg6fSSGziw79ndy-adRnBzdTC1MzqJFWTxfRJQRUicELTN3X6KyXObCc7JjQZfK79FGvZASg_YXPrCah1UfDxhe-1c0A_v-or0xq05JsW',
    'https://www.kindpng.com/picc/m/20-207346_works-with-amazon-alexa-logo-png-transparent-png.png',
    'https://framerusercontent.com/images/Bv0nXQAgzCxD2Ci6Mb6uyIqW1g.png?width=420&height=120',
    'https://vos.line-scdn.net/linecorp/ja/pr/clova_logo.png',
    'https://imageio.forbes.com/specials-images/imageserve/605b94296f382657b3613292/0x0.jpg?format=jpg&height=600&width=1200&fit=bounds',
    'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Matter_logo.jpg/1200px-Matter_logo.jpg'
  ];

  return (
    <section className="brands">
      <div className="brands-container">
        <span className="section-badge">PREMIUM AQARA PARTNER</span>
        <h2 className="brands-title">Brands in our Smart Ecosystem</h2>
        
        <div className="brands-logo-container">
          <div className="brands-marquee">
            <div className="marquee-track">
              {logos.map((logo, index) => (
                <div key={`logo-1-${index}`} className="brand-logo-item">
                  <img src={logo} alt={`Brand ${index + 1}`} />
                </div>
              ))}
              {logos.map((logo, index) => (
                <div key={`logo-2-${index}`} className="brand-logo-item">
                  <img src={logo} alt={`Brand ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <a href="https://wa.me/+94774641111" className="schedule-btn">
          Schedule a Meeting
        </a>
      </div>
    </section>
  );
};

export default Brands;
